import * as palette from "@govlaunch/palette";
import ProfilePicture from "@govlaunch/profile-picture";
import React from "react";
import { FormattedMessage } from "react-intl";
import FollowUs from "~/components/follow/FollowUs";
import Website from "~/components/profile/Website";
import { Margin } from "~/components/spacings";
import BetaBadge from "~/components/group/BetaBadge";
import { IGroupProps } from "~/components/group/IGroupProps";

export default function GroupInfo({ group }: IGroupProps) {
  return (
    <div
      css={{
        borderRadius: 5,
        border: `1px solid ${palette.lightestGray}`,
        background: "#fff",
        padding: 24,
        position: "relative",
      }}
      data-intercom-target="Group Details"
    >
      <span
        css={{
          position: "absolute",
          top: 8,
          right: 8,
        }}
      >
        <BetaBadge />
      </span>

      <div
        css={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ProfilePicture image={group.logo} name={group.name} size={80} />
      </div>

      <div>
        <p
          css={{
            margin: 0,
            fontSize: 12,
            fontWeight: 500,
            color: palette.sealBlue,
            textAlign: "center",
            marginTop: 16,
          }}
        >
          {group.location} • {group.membersCount}{" "}
          <FormattedMessage
            defaultMessage="{count, plural, one {member} other {members}}"
            id="pGeZ6M"
            values={{ count: group.membersCount }}
          />
        </p>
      </div>

      <Margin mt={16}>
        <h1
          css={{
            margin: 0,
            fontSize: 24,
            fontWeight: "bold",
            color: palette.text,
            wordBreak: "break-word",
            textAlign: "center",
          }}
        >
          {group.name}
        </h1>
      </Margin>

      <Margin mt={22}>
        <p
          css={{
            margin: 0,
            fontSize: 16,
            lineHeight: "20px",
            letterSpacing: 0.6,
            color: palette.text,
            wordBreak: "break-word",
          }}
        >
          {group.about}
        </p>
      </Margin>

      <Margin mt={22}>
        <div
          css={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "100%",
          }}
        >
          {group.website && <Website url={group.website} />}

          {!group.socialMedia ||
            (!group.socialMedia.instagram &&
              !group.socialMedia.youtube &&
              !group.socialMedia.linkedin &&
              !group.socialMedia.linkedin &&
              !group.socialMedia.facebook && (
                <div
                  css={{
                    marginTop: 16,
                  }}
                >
                  <FollowUs socialMedia={group.socialMedia} size={24} />
                </div>
              ))}
        </div>
      </Margin>
    </div>
  );
}
